export class ItemHistorialCrediticio {
    mes;
    deuda_total;
    deuda_vencida;
    institucion;
    observacion;
    constructor() {
        this.mes = null;
        this.deuda_total = 0;
        this.deuda_vencida = 0;
        this.institucion = null;
        this.observacion = null;
    }
}
